import { readsApi } from './api';
import type { AuditLog, PaginatedResponse } from '@apptypes/index';

export interface ListAuditLogsParams {
  action?: string;
  entityType?: string;
  entityId?: string;
  userId?: string;
  businessId?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface AuditFacets {
  actions: string[];
  entityTypes: string[];
}

export const auditService = {
  list: (params?: ListAuditLogsParams) =>
    readsApi.get<PaginatedResponse<AuditLog>>(
      '/admin/audit-logs',
      params as Record<string, unknown>,
    ),

  facets: () => readsApi.get<AuditFacets>('/admin/audit-logs/facets'),

  get: (logId: string, createdAt: string) =>
    readsApi.get<AuditLog>(`/admin/audit-logs/${logId}`, {
      createdAt,
    } as Record<string, unknown>),
};
